import { render, staticRenderFns } from "./SongorooAdminsTableItem.vue?vue&type=template&id=7114960c&"
import script from "./SongorooAdminsTableItem.vue?vue&type=script&lang=ts&"
export * from "./SongorooAdminsTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports